import { useState } from "react";
import { WelcomePage } from "./WelcomePage";
import { ValidatePage } from "./ValidatePage";
import { LoadingPage } from "./LoadingPage";
import "./styles.css";

export const HomeModule = ({ loadModels, runNextModule, onGeoBlock }) => {
  const [currentStep, updateCurrentStep] = useState(0);

  const loadNextStep = () => {
    updateCurrentStep((prevState) => prevState + 1);
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <ValidatePage onFinish={loadNextStep} />;
      case 2:
        return (
          <LoadingPage
            onBegin={() => loadModels()}
            onFinish={runNextModule}
            onGeoBlock={onGeoBlock}
          />
        );
      default:
        return <WelcomePage onFinish={loadNextStep} />;
    }
  };

  return <div className="home">{renderCurrentStep()}</div>;
};
